import type { ThemeClasses } from "../types";
import PaginationControls from "../../../../../../components/base/PaginationControls";

interface TrackingLinkPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  themeClasses?: ThemeClasses;
}

export function TrackingLinkPagination({
  currentPage,
  totalPages,
  onPageChange,
}: Omit<TrackingLinkPaginationProps, "themeClasses">) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
